export default __webpack_public_path__ + "static/media/error-cross.7f7ed6b9.svg";